<blaze-dialog
  (closeDialog)="closeDialog()"
  [showFooter]="true"
  class="blaze-table-copy-data-dialog"
>
  <div icon class="header-icon">
    <mat-icon svgIcon="icon_paste_16" class="icon-16" />
  </div>

  <div title>Copy Data from {{ sourceEnvironmentAbbrv() }} environment</div>

  <div content class="modal-content">
    <div class="header">
      This will add {{ sourceEnvironment() }} data to {{ currentEnvironment() }}
    </div>

    <div class="message">
      Schema stays the same. Only records are copied. No data will be removed or overwritten.
    </div>
  </div>

  <div footer class="footer">
    <button
      (click)="closeDialog()"
      class="bd-btn bd-btn-secondary uppercase"
      data-cy="BlazeTableCopyDataDialog:cancel"
    >
      Cancel
    </button>
    <button
      (click)="confirm()"
      class="bd-btn bd-btn-primary uppercase"
      data-cy="BlazeTableCopyDataDialog:copyData"
    >
      Copy Data
    </button>
  </div>
</blaze-dialog>
